// Tracking recently viewed items (defined globally to avoid event listener race conditions)
window.trackProductView = (handle, title, price, img) => {
  try {
    let list = JSON.parse(localStorage.getItem('ppk_recently_viewed') || '[]');
    list = list.filter(item => item && item.handle !== handle);
    list.unshift({ handle, title, price, img });
    if (list.length > 8) {
      list.pop();
    }
    localStorage.setItem('ppk_recently_viewed', JSON.stringify(list));
  } catch (e) {
    console.error("Error tracking product view:", e);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  // Intersection Observer for scroll-reveal animations
  const io = new IntersectionObserver((es) => {
    es.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('ppk-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });

  const run = () => {
    document.querySelectorAll('.ppk-reveal:not(.ppk-in)').forEach((n, i) => {
      n.style.animationDelay = ((i % 6) * 0.06) + 's';
      io.observe(n);
    });
  };
  
  setTimeout(run, 60);
  setTimeout(run, 400);
  setTimeout(run, 1200);
  
  const revealAll = () => {
    document.querySelectorAll('.ppk-reveal:not(.ppk-in)').forEach(n => n.classList.add('ppk-in'));
  };
  setTimeout(revealAll, 1800);

  // Cart counts (since this is a wireframe / mockup theme, mock local storage integration)
  window.ppkCartCount = parseInt(localStorage.getItem('ppk_cart_count') || '0', 10);
  
  const updateCartBadge = () => {
    const badges = document.querySelectorAll('.ppk-cart-badge');
    badges.forEach(b => {
      b.textContent = window.ppkCartCount;
      if (window.ppkCartCount > 0) {
        b.style.display = 'flex';
      } else {
        b.style.display = 'none';
      }
    });
  };
  updateCartBadge();

  window.addToCart = () => {
    window.ppkCartCount += 1;
    localStorage.setItem('ppk_cart_count', window.ppkCartCount);
    updateCartBadge();
    
    // Trigger pulse animation
    document.querySelectorAll('.ppk-cart-badge').forEach(b => {
      b.style.animation = 'none';
      b.offsetHeight; // trigger reflow
      b.style.animation = 'ppk-pulse .4s ease';
    });
  };

  // Bind add-to-cart clicks
  document.addEventListener('click', (e) => {
    const target = e.target.closest('.ppk-add-to-cart');
    if (target) {
      e.preventDefault();
      window.addToCart();
    }
  });

  // Newsletter subscription live Shopify integration
  // Allows standard Shopify form submission so reCAPTCHA challenges and customer records are handled natively
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.ppk-newsletter-form');
    if (form && !form.getAttribute('action')) {
      // For forms without action (fallback UI simulation)
      e.preventDefault();
      const input = form.querySelector('.ppk-newsletter-email');
      const successMsg = form.parentElement.querySelector('.ppk-newsletter-success');
      if (input && input.value.trim() && successMsg) {
        form.style.display = 'none';
        successMsg.style.display = 'inline-block';
      }
    }
  });

  // Coming Soon Modal popup logic
  const modal = document.getElementById('coming-soon-modal');
  const modalContent = document.getElementById('coming-soon-content');
  
  window.openComingSoon = () => {
    if (modal && modalContent) {
      modal.style.display = 'flex';
      setTimeout(() => {
        modal.style.opacity = '1';
        modalContent.style.transform = 'translateY(0)';
      }, 10);
    }
  };

  window.closeComingSoon = () => {
    if (modal && modalContent) {
      modal.style.opacity = '0';
      modalContent.style.transform = 'translateY(20px)';
      setTimeout(() => {
        modal.style.display = 'none';
      }, 300);
    }
  };

  // Toast Alert Notification
  window.showToast = (message, type = 'success') => {
    let container = document.getElementById('ppk-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'ppk-toast-container';
      container.style.cssText = 'position:fixed; bottom:24px; right:24px; z-index:99999; display:flex; flex-direction:column; gap:10px; pointer-events:none;';
      document.body.appendChild(container);
    }
    
    const toast = document.createElement('div');
    toast.style.cssText = 'background:#fff; border-left:4px solid var(--c-accent); padding:14px 20px; border-radius:12px; box-shadow:0 10px 30px rgba(122,143,100,0.12); font-family:"Quicksand"; font-weight:700; font-size:14px; color:#5a5147; display:flex; align-items:center; gap:10px; transform:translateX(100px); opacity:0; transition:all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); pointer-events:auto; border:1px solid rgba(156,175,136,0.15);';
    
    if (type === 'remove') {
      toast.style.borderLeftColor = '#e06c75';
    }
    
    toast.innerHTML = message;
    container.appendChild(toast);
    
    // Animate in
    setTimeout(() => {
      toast.style.transform = 'translateX(0)';
      toast.style.opacity = '1';
    }, 50);
    
    // Animate out and clean
    setTimeout(() => {
      toast.style.transform = 'translateX(100px)';
      toast.style.opacity = '0';
      setTimeout(() => {
        toast.remove();
      }, 300);
    }, 2800);
  };

  // Wishlist Manager
  let wishlist = JSON.parse(localStorage.getItem('ppk_wishlist') || '[]');
  
  window.updateWishlistBadge = () => {
    const badges = document.querySelectorAll('.ppk-wishlist-badge');
    const count = wishlist.length;
    badges.forEach(b => {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  };

  window.toggleWishlist = (id) => {
    const idx = wishlist.indexOf(id);
    let msg = "";
    let type = "success";
    if (idx > -1) {
      wishlist.splice(idx, 1);
      msg = "Removed from Wishlist 💔";
      type = "remove";
    } else {
      wishlist.push(id);
      msg = "Added to Wishlist! ❤️";
      type = "success";
    }
    localStorage.setItem('ppk_wishlist', JSON.stringify(wishlist));
    updateWishlistUI();
    window.updateWishlistBadge();
    window.showToast(msg, type);
  };

  const updateWishlistUI = () => {
    document.querySelectorAll('.wishlist-icon').forEach(icon => {
      const id = icon.dataset.id;
      if (wishlist.includes(id)) {
        icon.setAttribute('fill', 'var(--c-accent)');
        icon.setAttribute('stroke', 'var(--c-accent)');
      } else {
        icon.setAttribute('fill', 'none');
        icon.setAttribute('stroke', '#8c8276');
      }
    });
  };
  updateWishlistUI();
  window.updateWishlistBadge();

  // AJAX Cart Drawer logic
  const cartDrawer = document.getElementById('CartDrawer');
  const cartDrawerOverlay = document.getElementById('CartDrawerOverlay');

  window.openCartDrawer = () => {
    if (cartDrawer && cartDrawerOverlay) {
      cartDrawerOverlay.style.display = 'block';
      cartDrawer.style.display = 'flex';
      setTimeout(() => {
        cartDrawerOverlay.style.opacity = '1';
        cartDrawer.classList.add('open');
      }, 10);
      renderDrawerItems();
    }
  };

  window.closeCartDrawer = () => {
    if (cartDrawer && cartDrawerOverlay) {
      cartDrawerOverlay.style.opacity = '0';
      cartDrawer.classList.remove('open');
      setTimeout(() => {
        cartDrawerOverlay.style.display = 'none';
        cartDrawer.style.display = 'none';
      }, 300);
    }
  };

  // Bind cart icon clicks to open drawer
  document.querySelectorAll('a[href="/cart"]').forEach(cartLink => {
    if (cartLink.id === 'ViewCartBtn') return; // Let View Bag navigate normally
    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      window.openCartDrawer();
    });
  });
  // ── Real Shopify Cart integration ──
  window.refreshCartDrawer = async () => {
    const listContainer = document.getElementById('CartDrawerItems');
    const subtotalLabel = document.getElementById('CartDrawerSubtotal');
    const cartCountVal = document.querySelector('.cart-count-val');
    
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      
      // Update badges
      const totalQty = cart.item_count;
      window.ppkCartCount = totalQty;
      const badges = document.querySelectorAll('.ppk-cart-badge');
      badges.forEach(b => {
        b.textContent = totalQty;
        b.style.display = totalQty > 0 ? 'flex' : 'none';
      });
      if (cartCountVal) {
        cartCountVal.textContent = totalQty;
      }
      
      if (!listContainer) return;
      
      if (cart.items.length === 0) {
        listContainer.innerHTML = `
          <div style="text-align:center; padding:40px 0;">
            <div style="width:64px; height:64px; margin:0 auto 16px; background:var(--c-accent-soft); border-radius:50%; display:flex; align-items:center; justify-content:center;">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--c-accent)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
            </div>
            <p style="font-family:'Quicksand'; font-weight:600; color:#8c8276; margin:0;">Your cart is empty</p>
            <a href="/collections/all" class="ppk-btn" style="display:inline-block; text-decoration:none; background:var(--c-accent); color:#fff; font-family:'Quicksand'; font-weight:700; padding:10px 24px; border-radius:20px; font-size:14px; margin-top:14px; box-shadow:0 8px 16px var(--c-accent-sh);">Shop Collections</a>
          </div>`;
        if (subtotalLabel) subtotalLabel.textContent = '₹0';
        return;
      }
      
      let html = '';
      cart.items.forEach(item => {
        const itemImg = item.image 
          ? `<img src="${item.image}" style="width:100%; height:100%; object-fit:cover; border-radius:12px;">` 
          : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--c-accent)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>`;
        const formattedPrice = (item.price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
        
        html += `
          <div class="cart-item" data-line-item-key="${item.key}">
            <div style="width:70px; height:70px; display:flex; align-items:center; justify-content:center; background:var(--c-accent-soft); border-radius:12px; overflow:hidden; flex-shrink:0;">
              ${itemImg}
            </div>
            <div style="flex:1; display:flex; flex-direction:column; justify-content:space-between; min-width:0; padding-left:12px;">
              <div>
                <h4 style="font-family:'Quicksand'; font-weight:700; font-size:14px; color:#5a5147; line-height:1.2; margin:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${item.product_title}</h4>
                ${item.variant_title ? `<p style="font-size:11px; color:#8c8276; margin:2px 0 0 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${item.variant_title}</p>` : ''}
                <span style="font-family:'Quicksand'; font-weight:700; font-size:13px; color:var(--c-accent); display:block; margin-top:4px;">${formattedPrice}</span>
              </div>
              <div style="display:flex; align-items:center; justify-content:space-between; margin-top:6px;">
                <div style="display:flex; align-items:center; gap:6px;">
                  <button class="qty-btn" onclick="updateQty('${item.key}', ${item.quantity - 1})">-</button>
                  <span style="font-family:'Quicksand'; font-weight:700; font-size:13px; color:#5a5147;">${item.quantity}</span>
                  <button class="qty-btn" onclick="updateQty('${item.key}', ${item.quantity + 1})">+</button>
                </div>
                <button onclick="updateQty('${item.key}', 0)" style="background:none; border:none; color:#e06c75; font-size:12px; cursor:pointer; font-family:'Quicksand'; font-weight:600;">Remove</button>
              </div>
            </div>
          </div>`;
      });
      listContainer.innerHTML = html;
      
      if (subtotalLabel) {
        subtotalLabel.textContent = (cart.total_price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
      }

      // Dynamically update Buy 2 for 999 Deal Tracker
      const dealTracker = document.getElementById('CartDrawerDealTracker');
      if (dealTracker) {
        let totalCount = 0;
        cart.items.forEach(item => {
          totalCount += item.quantity;
        });
        dealTracker.setAttribute('data-qualifying-count', totalCount);
        const dealText = document.getElementById('CartDrawerDealText');
        const dealCount = document.getElementById('CartDrawerDealCount');
        const dealBar = document.getElementById('CartDrawerDealBar');
        const dealShopLink = document.getElementById('CartDrawerDealShopLink');
        const offerPrice = dealTracker.getAttribute('data-price') || '₹999';

        if (totalCount >= 2) {
          if (dealText) dealText.innerHTML = `🎉 <strong>Offer Unlocked:</strong> 2 for ${offerPrice}!`;
          if (dealCount) dealCount.textContent = '2/2 Ready';
          if (dealBar) dealBar.style.width = '100%';
          if (dealShopLink) dealShopLink.style.display = 'none';
        } else if (totalCount === 1) {
          if (dealText) dealText.innerHTML = `⚡ Add <strong>1 more</strong> to get 2 for ${offerPrice}!`;
          if (dealCount) dealCount.textContent = '1/2';
          if (dealBar) dealBar.style.width = '50%';
          if (dealShopLink) dealShopLink.style.display = 'block';
        } else {
          if (dealText) dealText.innerHTML = `🔥 <strong>Deal:</strong> Buy any 2 for ${offerPrice}!`;
          if (dealCount) dealCount.textContent = '0/2';
          if (dealBar) dealBar.style.width = '0%';
          if (dealShopLink) dealShopLink.style.display = 'block';
        }
      }
    } catch (e) {
      console.error("Error refreshing cart drawer:", e);
    }
  };

  window.addToCartDirect = async (handleOrVariantId) => {
    let variantId = handleOrVariantId;
    
    // If handleOrVariantId is not a number, treat it as a product handle
    if (isNaN(handleOrVariantId)) {
      try {
        const res = await fetch(`/products/${handleOrVariantId}.js`);
        const product = await res.json();
        variantId = product.variants[0].id;
      } catch (e) {
        console.error("Error fetching product variant:", e);
        return;
      }
    }
    
    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });
      await window.refreshCartDrawer();
      window.openCartDrawer();
      window.showToast("Added to Cart! 🛒", "success");
    } catch (e) {
      console.error("Error adding to Shopify cart:", e);
    }
  };

  window.updateQty = async (key, qty) => {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: qty
        })
      });
      await window.refreshCartDrawer();
      if (window.location.pathname === '/cart') {
        window.location.reload();
      }
    } catch (e) {
      console.error("Error updating cart quantity:", e);
    }
  };

  window.addProductToCart = async () => {
    const variantIdInput = document.getElementById('SelectedVariantId');
    const variantId = variantIdInput ? variantIdInput.value : null;
    if (!variantId) {
      console.error("No variant ID selected");
      return;
    }
    
    const qtyVal = document.getElementById('ProductQtyVal');
    const qty = qtyVal ? parseInt(qtyVal.textContent) : 1;

    const item = { id: variantId, quantity: qty };
    const props = (window.ppkGetLineProps && window.ppkGetLineProps()) || {};
    if (Object.keys(props).length) item.properties = props;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      await window.refreshCartDrawer();
      window.openCartDrawer();
      window.showToast("Added to Cart! 🛒", "success");
    } catch (e) {
      console.error("Error adding to Shopify cart:", e);
    }
  };

  window.buyNowDirect = async () => {
    const variantIdInput = document.getElementById('SelectedVariantId');
    const variantId = variantIdInput ? variantIdInput.value : null;
    if (!variantId) return;
    
    const qtyVal = document.getElementById('ProductQtyVal');
    const qty = qtyVal ? parseInt(qtyVal.textContent) : 1;

    const item = { id: variantId, quantity: qty };
    const props = (window.ppkGetLineProps && window.ppkGetLineProps()) || {};
    if (Object.keys(props).length) item.properties = props;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      window.location.href = '/checkout';
    } catch (e) {
      console.error("Error in Buy Now:", e);
    }
  };

  // Run initial cart refresh on script load
  window.refreshCartDrawer();

  window.switchMainEmoji = (emoji) => {
    const mainWrap = document.getElementById('ProdMainEmoji');
    if (mainWrap) {
      mainWrap.textContent = emoji;
    }
  };

  // Tabs Switcher
  window.switchTab = (tabId, element) => {
    element.parentElement.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    element.classList.add('active');
    
    const contentPanel = document.getElementById(tabId);
    contentPanel.parentElement.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
    contentPanel.classList.add('active');
  };

  // Size Guide trigger
  window.openSizeGuide = () => {
    const sgModal = document.getElementById('SizeGuideModal');
    const sgContent = document.getElementById('SizeGuideContent');
    if (sgModal && sgContent) {
      sgModal.style.display = 'flex';
      setTimeout(() => {
        sgModal.style.opacity = '1';
        sgContent.style.transform = 'translateY(0)';
      }, 10);
    }
  };
  window.closeSizeGuide = () => {
    const sgModal = document.getElementById('SizeGuideModal');
    const sgContent = document.getElementById('SizeGuideContent');
    if (sgModal && sgContent) {
      sgModal.style.opacity = '0';
      sgContent.style.transform = 'translateY(20px)';
      setTimeout(() => {
        sgModal.style.display = 'none';
      }, 300);
    }
  };

  // Care Guide trigger
  window.openCareGuide = () => {
    const cgModal = document.getElementById('CareGuideModal');
    const cgContent = document.getElementById('CareGuideContent');
    if (cgModal && cgContent) {
      cgModal.style.display = 'flex';
      setTimeout(() => {
        cgModal.style.opacity = '1';
        cgContent.style.transform = 'translateY(0)';
      }, 10);
    }
  };
  window.closeCareGuide = () => {
    const cgModal = document.getElementById('CareGuideModal');
    const cgContent = document.getElementById('CareGuideContent');
    if (cgModal && cgContent) {
      cgModal.style.opacity = '0';
      cgContent.style.transform = 'translateY(20px)';
      setTimeout(() => {
        cgModal.style.display = 'none';
      }, 300);
    }
  };
  window.switchSizeTab = (type) => {
    const babyBtn = document.getElementById('SizeTabBabyBtn');
    const kidsBtn = document.getElementById('SizeTabKidsBtn');
    const babyChart = document.getElementById('SizeChartBaby');
    const kidsChart = document.getElementById('SizeChartKids');
    
    if (type === 'baby') {
      babyBtn.classList.add('active');
      kidsBtn.classList.remove('active');
      babyChart.style.display = 'block';
      kidsChart.style.display = 'none';
    } else {
      kidsBtn.classList.add('active');
      babyBtn.classList.remove('active');
      kidsChart.style.display = 'block';
      babyChart.style.display = 'none';
    }
  };

  // Sticky ATC Observer
  const stickyAtc = document.getElementById('StickyATC');
  if (stickyAtc) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        stickyAtc.classList.add('show');
      } else {
        stickyAtc.classList.remove('show');
      }
    });
  }

  // Predictive Search query trigger
  const searchInput = document.getElementById('SearchInput');
  const searchResults = document.getElementById('PredictiveSearchResults');
  const trendingSec = document.getElementById('SearchTrending');
  const sugSec = document.getElementById('SearchSuggestions');
  const sugList = document.getElementById('SearchSuggestionsList');

  if (searchInput && searchResults) {
    searchInput.addEventListener('focus', () => {
      searchResults.style.display = 'block';
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('#PredictiveSearchContainer')) {
        searchResults.style.display = 'none';
      }
    });

    searchInput.addEventListener('input', (e) => {
      const q = e.target.value.trim().toLowerCase();
      if (q.length > 0) {
        trendingSec.style.display = 'none';
        sugSec.style.display = 'block';
        
        // Mock suggestion filtering based on catalog
        const matches = [
          { name: 'Organic Onesie', emoji: '👶', url: '/products/onesie' },
          { name: 'Wooden Sorter', emoji: '🧸', url: '/products/sorter' },
          { name: 'Kids Sweatshirt', emoji: '🧥', url: '/products/sweatshirt' }
        ].filter(item => item.name.toLowerCase().includes(q));

        if (matches.length > 0) {
          sugList.innerHTML = matches.map(item => `
            <a href="${item.url}" class="predictive-search-item">
              <div style="font-size:24px; width:36px; height:36px; display:flex; align-items:center; justify-content:center; background:var(--c-accent-soft); border-radius:6px;">
                ${item.emoji}
              </div>
              <span style="font-family:'Quicksand'; font-weight:700; font-size:14px; color:#5a5147;">${item.name}</span>
            </a>
          `).join('');
        } else {
          sugList.innerHTML = '<p style="font-size:13px; color:#8c8276; padding:8px;">No matches found</p>';
        }
      } else {
        trendingSec.style.display = 'block';
        sugSec.style.display = 'none';
      }
    });
  }

  // Dynamic add to bundle
  window.addBundleToCart = (p1_title, p1_price, p2_title, p2_price) => {
    const mainImg = document.getElementById('ProductMainImage');
    let img1 = '👶';
    if (mainImg && mainImg.src) img1 = mainImg.src;
    
    window.addToCartDirect(p1_title, p1_price / 100, img1);
    window.addToCartDirect(p2_title, p2_price / 100, '🧸');
  };

  // ==========================================
  // CUSTOM DASHBOARD & PROFILE LOGIC
  // ==========================================
  
  // Tab switcher
  window.switchDashboardTab = (tabId, focusFieldId = null) => {
    // Hide all tab panels
    document.querySelectorAll('.dashboard-tab-panel').forEach(panel => {
      panel.classList.remove('active');
    });
    
    // Deactivate all sidebar buttons
    document.querySelectorAll('.sidebar-nav-btn').forEach(btn => {
      btn.classList.remove('active');
    });
    
    // Show selected panel
    const activePanel = document.getElementById(`tab-${tabId}`);
    if (activePanel) {
      activePanel.classList.add('active');
    }
    
    // Activate corresponding nav button
    const activeBtn = document.getElementById(`nav-${tabId}`);
    if (activeBtn) {
      activeBtn.classList.add('active');
    }
    
    // Render wishlist if selected
    if (tabId === 'wishlist') {
      renderWishlist();
    }
    
    // Focus optional fields (for Phone and Email menus)
    if (focusFieldId) {
      setTimeout(() => {
        let inputField;
        if (focusFieldId === 'phone') {
          inputField = document.querySelector('input[name="customer[phone]"]');
        } else if (focusFieldId === 'email') {
          alert("To update your login email address, please contact support or update via Shopify Customer settings.");
          inputField = document.querySelector('input[name="customer[first_name]"]');
        }
        if (inputField) {
          inputField.focus();
          inputField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  };

  // Form submit simulation
  const profileForm = document.getElementById('profile-edit-form');
  if (profileForm) {
    profileForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const successBanner = document.getElementById('profile-save-success');
      if (successBanner) {
        successBanner.style.display = 'block';
        
        // Dynamic name update in sidebar
        const fName = profileForm.querySelector('input[name="customer[first_name]"]').value;
        const lName = profileForm.querySelector('input[name="customer[last_name]"]').value;
        const sidebarName = document.querySelector('.dashboard-sidebar h2');
        if (sidebarName && fName) {
          sidebarName.textContent = `${fName} ${lName}`;
        }
        
        setTimeout(() => {
          successBanner.style.display = 'none';
        }, 5000);
      }
    });
  }



  // Populate Recently Viewed Slider on Dashboard
  const renderRecentlyViewed = () => {
    const slider = document.getElementById('recently-viewed-slider');
    if (!slider) return;
    
    let list = JSON.parse(localStorage.getItem('ppk_recently_viewed') || '[]');
    
    // Fallbacks if empty
    if (list.length === 0) {
      list = [
        { handle: 'bear-ears-sweater', title: 'Bear Ears Sweater', price: 2400, img: '🐻' },
        { handle: 'classic-cotton-shirt', title: 'Classic Cotton Shirt', price: 1600, img: '👕' },
        { handle: 'organic-ribbed-legging', title: 'Organic Ribbed Legging', price: 900, img: '👖' },
        { handle: 'corduroy-play-pants', title: 'Corduroy Play Pants', price: 2100, img: '👖' }
      ];
    }
    
    slider.innerHTML = list.map(item => {
      return `
        <div class="ppk-reveal ppk-in" style="flex: 0 0 240px; scroll-snap-align: start; background: #fff; border-radius: 20px; border: 1px solid rgba(156,175,136,0.14); overflow: hidden; display: flex; flex-direction: column; position: relative; box-shadow: 0 8px 24px rgba(122,143,100,0.04); transition: transform 0.3s ease;">
          <a href="/products/${item.handle}" style="display: block; aspect-ratio: 1; background: var(--c-accent-soft); overflow: hidden; position: relative; text-decoration: none; font-size: 60px; display: flex; align-items: center; justify-content: center; user-select: none;">
            ${item.img && item.img.length <= 4 ? item.img : `<img src="${item.img}" style="width:100%; height:100%; object-fit:cover;">`}
          </a>
          <div style="padding: 12px 14px; flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
            <h4 style="font-family: 'Quicksand'; font-weight: 700; font-size: 13.5px; color: #5a5147; margin: 0; line-height: 1.25;">
              <a href="/products/${item.handle}" style="text-decoration: none; color: inherit;">${item.title}</a>
            </h4>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 8px;">
              <span style="font-family: 'Quicksand'; font-weight: 700; font-size: 14px; color: var(--c-accent);">₹${item.price}</span>
            </div>
          </div>
        </div>
      `;
    }).join('');
  };
  renderRecentlyViewed();

  window.scrollRecentlyViewed = (amt) => {
    const slider = document.getElementById('recently-viewed-slider');
    if (slider) {
      slider.scrollBy({ left: amt, behavior: 'smooth' });
    }
  };

  // Populate Wishlist items on Dashboard
  const renderWishlist = () => {
    const grid = document.getElementById('wishlist-items-grid');
    if (!grid) return;
    
    let wishlistIds = JSON.parse(localStorage.getItem('ppk_wishlist') || '[]');
    
    if (wishlistIds.length === 0) {
      grid.innerHTML = `
        <div class="wishlist-empty-msg" style="grid-column: 1/-1; text-align: center; padding: 40px 0; color: #8c8276;">
          <span style="font-size: 48px; display: block; margin-bottom: 12px;">❤️</span>
          <p style="font-family: 'Quicksand'; font-weight: 600;">Your wishlist is empty</p>
          <a href="/collections/all" class="ppk-btn" style="display: inline-block; text-decoration: none; background: var(--c-accent); color: #fff; font-family: 'Quicksand'; font-weight: 700; padding: 10px 24px; border-radius: 20px; font-size: 14px; margin-top: 12px; box-shadow: 0 8px 16px var(--c-accent-sh);">Explore Products</a>
        </div>
      `;
      return;
    }
    
    // Resolve wishlist titles/IDs to mock data
    const allProducts = [
      { id: '1', handle: 'bear-ears-sweater', title: 'Bear Ears Sweater', price: 2400, img: '🐻' },
      { id: '2', handle: 'classic-cotton-shirt', title: 'Classic Cotton Shirt', price: 1600, img: '👕' },
      { id: '3', handle: 'organic-ribbed-legging', title: 'Organic Ribbed Legging', price: 900, img: '👖' },
      { id: '4', handle: 'corduroy-play-pants', title: 'Corduroy Play Pants', price: 2100, img: '👖' },
      { id: '5', handle: 'linen-summer-dress', title: 'Linen Summer Dress', price: 2500, img: '👗' }
    ];
    
    const matched = allProducts.filter(p => wishlistIds.includes(p.id) || wishlistIds.includes(p.title));
    
    if (matched.length === 0) {
      grid.innerHTML = wishlistIds.map(title => {
        return `
          <div style="background: #fff; border-radius: 20px; border: 1px solid rgba(156,175,136,0.14); overflow: hidden; display: flex; flex-direction: column; padding: 16px; position: relative;">
            <div style="font-size: 40px; text-align: center; margin-bottom: 10px;">👶</div>
            <h4 style="font-family: 'Quicksand'; font-weight: 700; font-size: 14px; color: #5a5147; text-align: center;">${title}</h4>
            <button onclick="toggleWishlist('${title}'); renderWishlist();" style="border: none; background: none; color: #e06c75; font-size: 12px; cursor: pointer; text-decoration: underline; margin-top: 8px;">Remove</button>
          </div>
        `;
      }).join('');
      return;
    }
    
    grid.innerHTML = matched.map(item => `
      <div style="background: #fff; border-radius: 20px; border: 1px solid rgba(156,175,136,0.14); overflow: hidden; display: flex; flex-direction: column; position: relative; box-shadow: 0 8px 24px rgba(122,143,100,0.04);">
        <button onclick="toggleWishlist('${item.id}'); renderWishlist();" style="position: absolute; top: 12px; right: 12px; background: #fff; border: none; width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.06); z-index: 5;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="var(--c-accent)" stroke="var(--c-accent)" stroke-width="2">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
        </button>
        <a href="/products/${item.handle}" style="display: block; aspect-ratio: 1; background: var(--c-accent-soft); overflow: hidden; display: flex; align-items: center; justify-content: center; font-size: 50px; text-decoration: none;">
          ${item.img}
        </a>
        <div style="padding: 12px; display: flex; flex-direction: column; gap: 4px;">
          <h4 style="font-family: 'Quicksand'; font-weight: 700; font-size: 13.5px; color: #5a5147; margin: 0;">
            <a href="/products/${item.handle}" style="text-decoration: none; color: inherit;">${item.title}</a>
          </h4>
          <span style="font-family: 'Quicksand'; font-weight: 700; font-size: 14px; color: var(--c-accent);">₹${item.price}</span>
        </div>
      </div>
    `).join('');
  };

  // URL query parameter tab auto-selection on page load
  const urlParams = new URLSearchParams(window.location.search);
  const initialTab = urlParams.get('tab');
  if (initialTab && ['profile', 'orders', 'addresses', 'wishlist'].includes(initialTab)) {
    setTimeout(() => {
      window.switchDashboardTab(initialTab);
    }, 120);
  }
});
